import { getMyEnrollments } from "@/lib/api";
import { queryKeys } from "@/lib/query-keys";
import { useQuery } from "@tanstack/react-query";

export function useEnrollments() {
	return useQuery({
		queryKey: queryKeys.enrollments,
		queryFn: getMyEnrollments,
		select: (data) => data.enrollments,
		staleTime: 30_000,
	});
}
